import { useEffect } from "react";
import SubmissionsPageText from "../components/SubmissionsPageText"

function Submissions(props) {
    useEffect(() => {
        props.funcNav(true);
        window.scrollTo(0, 0);
        // Disables click right to download images: 
        // https://stackoverflow.com/questions/35043748/disable-right-click-in-react-js
        const handleContextmenu = e => {
            e.preventDefault()
        }
        document.addEventListener('contextmenu', handleContextmenu)
        return function cleanup() {
            document.removeEventListener('contextmenu', handleContextmenu)
        }
    }, [props]);

    return (
        <main>
            <SubmissionsPageText />
        </main>
    )

}
export default Submissions;